(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-faq"] && !Shopify.designMode) return;
  try {
    
  // A link to a question (e.g. "#faq-question-fit" from the reassurance lines
  // under the add button) opens its answer, also when the page loads with it.
  const openFaqQuestion = (hash) => {
    if (!hash || hash.length < 2) return;
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (target instanceof HTMLDetailsElement && target.classList.contains('hh-faq__item')) target.open = true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
    if (link) openFaqQuestion(link.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => openFaqQuestion(window.location.hash));
  openFaqQuestion(window.location.hash);

  // Theme editor only: open a question when it's selected in the sidebar.
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    if (target instanceof HTMLDetailsElement && target.classList.contains('hh-faq__item')) {
      target.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
